import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getLimitInfo, isLimitApproaching, getLimitText } from '../../services/featureService';

const LimitWarning = ({ limitType, showAlways = false }) => {
  const navigate = useNavigate();
  const limitInfo = getLimitInfo(limitType);
  const isApproaching = isLimitApproaching(limitType);

  // If limit is null (unlimited) or not approaching and showAlways is false, don't show anything
  if ((limitInfo.max === null || (!isApproaching && !showAlways)) && limitInfo.within_limit) {
    return null;
  }

  // Get appropriate text based on limit type
  const limitName = limitType === 'users' ? 'user' : 'monthly appreciation';
  const limitText = getLimitText(limitType);

  // If limit exceeded, show error
  if (!limitInfo.within_limit) {
    return (
      <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm leading-5 font-medium text-red-800">
              {limitName.charAt(0).toUpperCase() + limitName.slice(1)} limit reached: {limitText}
            </h3>
            <div className="mt-2">
              <p className="text-sm leading-5 text-red-700">
                You've reached your {limitName} limit on your current plan.
              </p>
              <button
                onClick={() => navigate('/admin/subscriptions')}
                className="mt-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-5 font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:border-red-300 focus:shadow-outline-red active:bg-red-300 transition ease-in-out duration-150"
              >
                Upgrade to Pro
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If approaching limit, show warning
  if (isApproaching) {
    return (
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm leading-5 font-medium text-yellow-800">
              Approaching {limitName} limit: {limitText}
            </h3>
            <div className="mt-2">
              <p className="text-sm leading-5 text-yellow-700">
                You're approaching your {limitName} limit on your current plan.
              </p>
              <button
                onClick={() => navigate('/admin/subscriptions')}
                className="mt-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-5 font-medium rounded-md text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:border-yellow-300 focus:shadow-outline-yellow active:bg-yellow-300 transition ease-in-out duration-150"
              >
                Upgrade to Unlimited
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If showing always, display usage
  if (showAlways) {
    return (
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
        <div className="flex">
          <div className="ml-3">
            <h3 className="text-sm leading-5 font-medium text-blue-800">
              Current {limitName} usage: {limitText}
            </h3>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default LimitWarning;